var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookUserActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1502_143)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1502_143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.473 9H15.6308C13.6714 9 12.1038 10.6056 12.1038 12.5769V16.9487H10.1757C9.53297 16.9487 9 17.4892 9 18.141C9 18.7928 9.53297 19.3333 10.1757 19.3333H12.1038V23.3077H10.1757C9.53297 23.3077 9 23.8482 9 24.5C9 25.1518 9.53297 25.6923 10.1757 25.6923H12.1038V29.6667H10.1757C9.53297 29.6667 9 30.2072 9 30.859C9 31.5108 9.53297 32.0513 10.1757 32.0513H12.1038V36.4231C12.1038 38.3944 13.687 40 15.6308 40H34.473C36.4168 40 38 38.3944 38 36.4231V12.5769C38 10.6056 36.4168 9 34.473 9ZM25.0362 15.9631C27.3562 15.9631 29.2373 17.8708 29.2373 20.2236C29.2373 22.5764 27.3562 24.4841 25.0362 24.4841C22.7162 24.4841 20.8351 22.5764 20.8351 20.2236C20.8351 17.8708 22.7162 15.9631 25.0362 15.9631ZM32.8584 31.8923C32.8584 33.2595 31.8865 34.3723 30.6638 34.3723H19.4086C18.1859 34.3723 17.1984 33.2595 17.1984 31.9082V30.3979C17.1984 29.3805 17.747 28.4744 18.5935 28.0928C22.7162 26.2964 27.3405 26.2964 31.4632 28.0928C32.3097 28.4585 32.8584 29.3646 32.8584 30.3821V31.8923Z",
    fill: "url(#paint0_linear_1502_143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6984 30.3979C18.6984 29.9031 18.9592 29.5768 19.2038 29.4631C22.9416 27.838 27.1272 27.8396 30.864 29.468L30.8684 29.4698C31.0906 29.5658 31.3584 29.8771 31.3584 30.3821V31.8923C31.3584 32.2223 31.2411 32.4867 31.0943 32.6532C30.9512 32.8155 30.7983 32.8723 30.6638 32.8723H19.4086C19.168 32.8723 18.6984 32.5935 18.6984 31.9082V30.3979ZM34.473 7.5H15.6308C12.8188 7.5 10.6038 9.80153 10.6038 12.5769V15.4487H10.1757C8.68475 15.4487 7.5 16.6807 7.5 18.141C7.5 19.6013 8.68475 20.8333 10.1757 20.8333H10.6038V21.8077H10.1757C8.68475 21.8077 7.5 23.0397 7.5 24.5C7.5 25.9603 8.68475 27.1923 10.1757 27.1923H10.6038V28.1667H10.1757C8.68475 28.1667 7.5 29.3987 7.5 30.859C7.5 32.3193 8.68475 33.5513 10.1757 33.5513H10.6038V36.4231C10.6038 39.2029 12.8388 41.5 15.6308 41.5H34.473C37.265 41.5 39.5 39.2029 39.5 36.4231V12.5769C39.5 9.79715 37.265 7.5 34.473 7.5ZM25.0362 17.4631C26.508 17.4631 27.7373 18.6793 27.7373 20.2236C27.7373 21.7679 26.508 22.9841 25.0362 22.9841C23.5644 22.9841 22.3351 21.7679 22.3351 20.2236C22.3351 18.6793 23.5644 17.4631 25.0362 17.4631Z",
    stroke: "#127081",
    strokeWidth: 3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1502_143",
    x: -24,
    y: -24,
    width: 95,
    height: 97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0409099 0 0 0 0 0.223218 0 0 0 0 0.254997 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1502_143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1502_143",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1502_143",
    x1: 16.0732,
    y1: 9,
    x2: 35.9332,
    y2: 39.9646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1FDFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1502_143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookUserActive);
export default __webpack_public_path__ + "static/media/book-user-active.78daaf641f1376169147af7470700385.svg";
export { ForwardRef as ReactComponent };